/**
 * 订单管理 交易订单
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>盘点单</el-breadcrumb-item>
    </el-breadcrumb>
    
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-date-picker
          v-model="date"
          type="date"
          placeholder="选择日期时间"
          @change="getData(date)"
          default-time="12:00:00"
        >
        </el-date-picker>
      </el-form-item>
      
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="addCount"
        >开始盘点单</el-button>
      </el-form-item>
      
      <!-- 新增：下载模板按钮 -->
      <el-form-item>
        <el-button
          size="small"
          type="warning"
          icon="el-icon-download"
          @click="downloadTemplate"
        >下载导入模板</el-button>
      </el-form-item>

      <!-- 新增：批量导入上传组件 -->
      <el-form-item>
        <el-upload
          class="upload-demo"
          action=""
          :show-file-list="false"
          :http-request="uploadExcel"
          accept=".xlsx, .xls"
          style="display: inline-block;"
        >
          <el-button
            size="small"
            type="success"
            icon="el-icon-upload2"
            :loading="uploading"
          >批量导入盘点</el-button>
        </el-upload>
      </el-form-item>

      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-download"
          @click="exportCount"
        >导出</el-button>
      </el-form-item>
    </el-form>
    
    <!--列表-->
    <el-table
      size="small"
      :data="goodsList"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column align="center" type="index" width="60"></el-table-column>
      <el-table-column prop="profitAmount" label="盈亏总金额" show-overflow-tooltip></el-table-column>
      <el-table-column prop="totalNum" label="盘点总数" show-overflow-tooltip></el-table-column>
      <el-table-column prop="remake" label="备注" show-overflow-tooltip></el-table-column>
      <el-table-column prop="createBy" label="创建人" show-overflow-tooltip></el-table-column>
      <el-table-column prop="createTime" label="创建时间" show-overflow-tooltip></el-table-column>
      <el-table-column align="center" label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    
    <!-- 分页组件 -->
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>
    
    <!-- 编辑界面 -->
    <el-dialog
      :title="title"
      :visible.sync="editFormVisible"
      width="50%"
      @close="closeDialog('editForm')"
    >
      <el-form label-width="250px" :model="editForm" ref="editForm">
        <el-row>
          <el-col>
            <el-table :data="editForm" style="width: 100%">
              <el-table-column prop="name" label="商品名称" width="180"></el-table-column>
              <el-table-column prop="profitAmount" label="盈亏金额"></el-table-column>
              <el-table-column prop="oldStock" label="原库存"></el-table-column>
              <el-table-column prop="num" label="盘点数"></el-table-column>
              <el-table-column prop="costPrice" label="进货价"></el-table-column>
              <el-table-column prop="barcode" label="条码" width="180"></el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog('editForm')">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { OrderList, OrderRefund, OrderDelete } from "../../api/payMG";
import Pagination from "../../components/Pagination";
import { blobValidate } from "@/utils/ruoyi";
import { saveAs } from "file-saver";
import {
  getGoodsList,
  getGoodsTypeList,
  getGoodsDetail,
  editGoodsInfo,
  getCountGoodsList, //获取盘点单列表
  getCountGoodsDetail, //获取盘点单详情
} from "@/api/api.js";

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      loading: false, //是显示加载
      uploading: false, // 控制上传按钮的loading状态
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: "预览",
      date: "",
      year: "",
      month: "",
      day: "",
      goodsStatus: "", //商品类型
      payway: [
        { key: "全部订单", value: 0 },
        { key: "已完成订单", value: 1 },
        { key: "已取消订单", value: 2 },
        { key: "已退款订单", value: 3 },
      ],
      goodsTypeList: [], //商品类型列表
      orderList: "", //订单列表
      goodName: "", //商品名称
      goodsList: [], //商品列表
      options: [
        { label: "是", value: 1 },
        { label: "否", value: 0 },
      ], //预下架选项
      editForm: [], // 修复：原代码里定义为对象，但在弹窗里又绑定给 <el-table :data="editForm">，应为数组
      formInline: {
        page: 1,
        limit: 10,
        machineNo: "",
        orderNo: "",
        transId: "",
        payType: 0,
        orderStatus: 0,
        token: localStorage.getItem("logintoken"),
      },
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  created() {
    let date = new Date();
    this.date = date;
    this.getGoodsType(); //获取商品类型列表
    this.getData(date); //获取盘点单列表
  },
  methods: {
    //获取商品类型列表
    getGoodsType() {
      getGoodsTypeList().then((res) => {
        res.data.forEach((item) => {
          item.key = item.name;
          item.value = item.id;
        });
        res.data.unshift({ key: "所有", value: "" });
        this.goodsTypeList = res.data;
      });
    },
    //获取盘点单列表
    getData(date) {
      this.loading = true;
      let data1 = date ? new Date(date) : new Date();
      this.startTime =
        data1.getFullYear() +
        "-" +
        ("0" + (data1.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + data1.getDate()).slice(-2);
        
      getCountGoodsList({
        startTime: this.startTime,
        pageNo: this.pageparm.currentPage,
        pageSize: this.pageparm.pageSize,
        storeId: localStorage.getItem("storeId"),
      }).then((res) => {
        this.goodsList = res.data.list;
        this.loading = false;
        this.pageparm.currentPage = this.formInline.page;
        this.pageparm.pageSize = this.formInline.limit;
        this.pageparm.total = res.data.total; // 修复：原代码取 length 会导致分页总数错误，应取后端的 total
      }).catch(() => {
        this.loading = false;
      });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.pageparm.currentPage = parm.currentPage;
      this.pageparm.pageSize = parm.pageSize;
      this.formInline.limit = parm.pageSize;
      this.getData(this.date);
    },
    // 添加订单
    addCount() {
      this.$router.push({
        path: "/goods/addCount",
      });
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      this.editForm = []; // 初始化清空
      //获取盘点单详情
      getCountGoodsDetail(row.id).then((res) => {
        this.editForm = res.data.yzsInventoryGoodsDtos || [];
      });
    },
    // 编辑、增加页面保存方法
    submitForm() {
      editGoodsInfo(this.editForm).then((res) => {
        if (res.code == 0 || res.code == 200) {
          this.$message.success("商品信息修改成功!");
          this.editFormVisible = false;
          this.getData(this.date);
        } else {
          this.$message.info(res.msg);
        }
      });
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false;
      this.editForm = [];
    },
    
    // ================= 新增：下载模板 =================
    downloadTemplate() {
      this.loading = true;
      this.$axios.get(this.$api.Domain + `/system/inventory/importTemplate`, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          token: localStorage.getItem("token")
        },
        responseType: "blob"
      }).then(async (res) => {
        const isLogin = await blobValidate(res);
        if (res.status === 200 && isLogin) {
          const blob = new Blob([res.data]);
          saveAs(blob, `盘点单批量导入模板.xlsx`);
          this.$message.success("模板下载成功");
        } else {
          this.$message.error("下载失败，请检查网络或权限");
        }
      }).catch(() => {
        this.$message.error("模板下载失败");
      }).finally(() => {
        this.loading = false;
      });
    },

    // ================= 新增：自定义批量上传文件请求 =================
    uploadExcel(param) {
      const file = param.file;
      // 校验文件类型，防止误传
      const isExcel = file.name.endsWith('.xlsx') || file.name.endsWith('.xls');
      if (!isExcel) {
        this.$message.warning("只能上传 Excel 文件!");
        return;
      }

      this.uploading = true;
      this.loading = true;
      
      const formData = new FormData();
      formData.append("file", file);
      formData.append("storeId", localStorage.getItem("storeId"));

      this.$axios.post(this.$api.Domain + `/system/inventory/import`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          token: localStorage.getItem("token")
        }
      }).then((res) => {
        if (res.data && (res.data.code === 0 || res.data.code === 200)) {
          this.$message.success("批量盘点导入成功！");
          // 导入成功后刷新当前页面的列表
          this.getData(this.date); 
        } else {
          this.$message.error(res.data.msg || "导入失败");
        }
      }).catch((err) => {
        console.error("上传错误:", err);
        this.$message.error("文件导入异常，请检查网络或文件格式");
      }).finally(() => {
        this.uploading = false;
        this.loading = false;
      });
    },

    // 导出盘点单 (原有代码，稍作规范优化)
    exportCount() {
      let startDate = new Date(this.date);
      let dateStr =
        startDate.getFullYear() +
        "-" +
        ("0" + (startDate.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + startDate.getDate()).slice(-2);
        
      this.$confirm("确定导出盘点单明细吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.loading = true;
        this.$axios.get(
          this.$api.Domain + `/system/inventory/export?storeId=${localStorage.getItem("storeId")}&startTime=${dateStr}`,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              token: localStorage.getItem("token")
            },
            responseType: "blob",
          }
        ).then(async (res) => {
          const isLogin = await blobValidate(res);
          if (res.status == 200 && isLogin) {
            const blob = new Blob([res.data]);
            saveAs(blob, `盘点单列表_${new Date().getTime()}.xlsx`);
            this.$message.success("导出成功");
          } else {
            this.$message.error("导出失败，暂无数据或权限不足");
          }
        }).catch(() => {
           this.$message.error("网络异常，导出失败");
        }).finally(() => {
           this.loading = false;
        });
      }).catch(() => {
        this.$message.info("已取消导出");
      });
    },
  },
};
</script>

<style scoped>

/* 保持上传按钮的内联对齐 */
.upload-demo {
  display: inline-block;
  margin-right: 10px;
}
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>







// WEBPACK FOOTER //
// src/views/goods/countGoods.vue